function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "none",
    stroke: "#F29E41",
    strokeWidth: 0.9765,
    strokeMiterlimit: 10,
    cx: 32.051998,
    cy: 32.102001,
    rx: 31.292999,
    ry: 31.200001,
    id: "ellipse1",
    style: {
      display: "none",
      stroke: "#ff6501",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 53.548204,15.672299 H 47.845995 L 47.20806,14.335652 a 2.8511044,2.9890089 0 0 0 -2.549955,-1.652361 h -4.777382 l -2.430567,-2.54813 C 36.551168,9.193622 35.016025,9.8605452 35.016025,11.191588 v 13.996034 l 11.404418,4.269613 v -3.323403 h 2.851104 c 3.14958,0 5.70221,-2.676098 5.70221,-5.97802 v -2.989009 c 0,-0.825713 -0.637935,-1.494504 -1.425553,-1.494504 z m -9.978867,4.483513 c -0.787616,0 -1.425551,-0.66879 -1.425551,-1.494503 0,-0.825714 0.637935,-1.494506 1.425551,-1.494506 0.787619,0 1.425554,0.668792 1.425554,1.494506 0,0.825713 -0.637935,1.494503 -1.425554,1.494503 z M 17.9094,27.628336 c -1.571671,0 -2.851105,-1.341318 -2.851105,-2.98901 0,-1.650493 -1.276761,-2.989008 -2.851104,-2.989008 -1.574345,0 -2.8511042,1.338515 -2.8511042,2.989008 0,3.891317 2.3904722,7.178292 5.7022082,8.415929 v 19.979659 c 0,0.825711 0.637935,1.494503 1.425552,1.494503 h 5.70221 c 0.787616,0 1.425551,-0.668792 1.425551,-1.494503 V 42.573379 h 14.255523 v 10.461535 c 0,0.825711 0.637935,1.494503 1.425552,1.494503 h 5.702208 c 0.787617,0 1.425552,-0.668792 1.425552,-1.494503 V 32.630255 L 33.060347,27.628336 Z",
    id: "path1-4",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#ff6501",
      strokeWidth: 1.48913386,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog);
export default __webpack_public_path__ + "static/media/dog.312862fa334f1dbc5ca570f0fa17066b.svg";
export { ForwardRef as ReactComponent };